import type { TPulseEventWithDateRanges } from 'App/irrigation-scheduler/utils/store/types'
import type { Moment } from 'moment-timezone'
import { sumEventDurationsInWindow } from './sumEventDurationsInWindow'

export const sumPulseEventDurations = (
  pulseEvents: TPulseEventWithDateRanges[],
  windowStart: Moment,
  windowEnd: Moment,
): number => {
  return pulseEvents.reduce((sum, pulseEvent) => {
    return sum + sumEventDurationsInWindow(pulseEvent.pulseIrrigationEvents, windowStart, windowEnd)
  }, 0)
}
